import {
    arbitrum,
    base,
    mainnet,
    optimism,
    polygon,
    sepolia,
    zora,
    goerli
} from 'wagmi/chains';

export default {
    chain:arbitrum,
    tokenDigitLength:1000000,
    contractAddress:'0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9',//usdt
    // apiUrl:'http://89.117.49.31',
    apiUrl:"https://act2.cess.network"
}
